import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const TooltipContainerDiv = styled.div`
  position: absolute;
  background: ${colors.darkBlue};
  padding: 5px 10px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  width: ${(props) => props.width || 150}px;
  bottom: 30%;
  transform: translateY(100%);
  z-index: 5;
  color: ${(props) => (props.light ? colors.darkGray : colors.white)};
  white-space: pre-wrap;
  display: inline-block;
  word-break: break-word;
  opacity: 0.95;
  pointer-events: none;

  :after {
    content: '';
    position: absolute;
    top: 1px;
    left: 50%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: ${colors.darkBlue};
    border-top: 0;
    margin-left: -10px;
    margin-top: -10px;
  }

  ${(props) =>
    props.isOutside &&
    css`
      ${[props.isOutside]}: 0;
      :after {
        left: calc(50% ${props.isOutside === 'left' ? '-' : '+'} 35px);
      }
    `}
`;
